import { jsx as _jsx } from "react/jsx-runtime";
import { StyledAgentRecoveryLinksComponent } from "./agent-recovery-links.scss";
// Rendered only on is404Page pages. Not-found pages otherwise give an agent/crawler no way
// to recover a broken crawl — this points it at the sitemap without adding visible clutter
// to the human-facing 404 design. llms.txt is deliberately not duplicated here — it's already
// in every page's <head> via LlmsTxtLinkComponent (rendered by HeaderScriptsComponent).
const AgentRecoveryLinksComponent = ()=>/*#__PURE__*/ _jsx(StyledAgentRecoveryLinksComponent, {
        "aria-label": "Recovery links",
        children: /*#__PURE__*/ _jsx("a", {
            href: "/sitemap_index.xml",
            children: "Sitemap"
        })
    });
export default AgentRecoveryLinksComponent;
